export const apiBase = "https://api.remaker.ai/";
export const env = "production";
export const domain = "api.remaker.ai";
export const pid = "067003";
